<template>
     <div class="sa-free-page">
    <!-- <div class="sa-free-page-header">
        HEADER
    </div> -->
    <div class="sa-free-page-body">
        <b-row>
            <b-col> 
            <b-form-checkbox v-model="stampaCartella" name="check-button" switch><span>STAMPA CARTELLA COMPLETA</span></b-form-checkbox>
            </b-col>

            <b-col cols="12">
                   <b-form-group label="Seleziona Tipologie Stampe" v-slot="{ ariaDescribedby }">
      <b-form-checkbox-group
      :disabled="stampaCartella"
        id="checkbox-group-1"
        v-model="selected"
        :options="jsonData"
        :aria-describedby="ariaDescribedby"
        name="stampe"
      ></b-form-checkbox-group>
    </b-form-group>
            </b-col>
        </b-row>
    </div>
    <div class="sa-free-page-footer">FOOTER</div>
  </div>
</template>

<script>
import UtilityMixin from '../../../utility/UtilityMixin';
    export default {
        mixins:[UtilityMixin],
        data(){
            return {
                pathResource:"",
                selected:[],
                stampe:{stampaCartella:this.stampaCartella, tipi:[]},
                jsonData:[{text:"SCHEDA VALUTAZIONE X",value:"SCHEDA VALUTAZIONE X"},{text:"ACCETTAZIONE",value:"ACCETTAZIONE"},{text:"SCHEDA VALUTAZIONE Y",value:"SCHEDA VALUTAZIONE Y"},{text:"SCHEDA ATTIVITA X",value:"SCHEDA ATTIVITA X"},{text:"SCHEDA ATTIVITA Y",value:"SCHEDA ATTIVITA Y"}],
                idAccettazione:null,
                stampaCartella:false,
            }
        },
        mounted(){
            this.idAccettazione = this.$route.query.idAccettazione;

        },
        methods:{
            loadData(){
                
            },
            loadDataSuccess(response){
                    console.log(response);
                    
            },
            loadDataError(error){
                console.log(error);
            },
            getSelectedStampe(){
                this.stampa.stampaCartella = this.stampaCartella
                return this.stampe;
            }
        },

        watch:{
            'selected':function (params) {
                
                this.stampe.tipi = params;
                
            },
            'stampaCartella':function (params) {
                 if(params){
                    this.selected = []
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>